"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DefaultDataFactory = require("@rdfjs/data-model");

var SparqlJsonBindingsTransformer_1 = require("./SparqlJsonBindingsTransformer");
/**
 * Parser for the SPARQL 1.1 Query Results JSON format.
 * @see https://www.w3.org/TR/sparql11-results-json/
 */


var SparqlJsonParser =
/*#__PURE__*/
function () {
  function SparqlJsonParser(settings) {
    _classCallCheck(this, SparqlJsonParser);

    settings = settings || {};
    this.dataFactory = settings.dataFactory || DefaultDataFactory;
    this.prefixVariableQuestionMark = !!settings.prefixVariableQuestionMark;
  }
  /**
   * Convert a SPARQL JSON bindings response to an array of bindings objects.
   * @param sparqlResponse A SPARQL JSON response.
   * @return {IBindings[]} An array of bindings.
   */


  _createClass(SparqlJsonParser, [{
    key: "parseJsonResults",
    value: function parseJsonResults(sparqlResponse) {
      var _this = this;

      return sparqlResponse.results.bindings.map(function (rawBindings) {
        return _this.parseJsonBindings(rawBindings);
      });
    }
    /**
     * Convert a SPARQL JSON bindings response stream to a stream of bindings objects.
     *
     * The bindings stream will emit a 'variables' event that will contain
     * the array of variables (as RDF.Variable[]), as defined in the response head.
     *
     * @param {NodeJS.ReadableStream} sparqlResponseStream A SPARQL JSON response stream.
     * @return {NodeJS.ReadableStream} A stream of bindings.
     */

  }, {
    key: "parseJsonResultsStream",
    value: function parseJsonResultsStream(sparqlResponseStream) {
      var _this2 = this;

      sparqlResponseStream.on('error', function (error) {
        return resultStream.emit('error', error);
      });
      var variables = [];
      sparqlResponseStream.pipe(require('JSONStream').parse('head.vars.*')).on('data', function (variable) {
        return variables.push(_this2.dataFactory.variable(variable));
      }).on('end', function () {
        return resultStream.emit('variables', variables);
      });
      var resultStream = sparqlResponseStream.pipe(require('JSONStream').parse('results.bindings.*')).pipe(new SparqlJsonBindingsTransformer_1.SparqlJsonBindingsTransformer(this));
      return resultStream;
    }
    /**
     * Convert a SPARQL JSON result binding to a bindings object.
     * @param rawBindings A SPARQL JSON result binding.
     * @return {IBindings} A bindings object.
     */

  }, {
    key: "parseJsonBindings",
    value: function parseJsonBindings(rawBindings) {
      var bindings = {};

      for (var key in rawBindings) {
        var rawValue = rawBindings[key];
        var value = null;

        switch (rawValue.type) {
          case 'bnode':
            value = this.dataFactory.blankNode(rawValue.value);
            break;

          case 'literal':
            if (rawValue['xml:lang']) {
              value = this.dataFactory.literal(rawValue.value, rawValue['xml:lang']);
            } else if (rawValue.datatype) {
              value = this.dataFactory.literal(rawValue.value, this.dataFactory.namedNode(rawValue.datatype));
            } else {
              value = this.dataFactory.literal(rawValue.value);
            }

            break;

          case 'typed-literal':
            // Virtuoso uses this non-spec-compliant way of defining typed literals
            value = this.dataFactory.literal(rawValue.value, this.dataFactory.namedNode(rawValue.datatype));
            break;

          default:
            value = this.dataFactory.namedNode(rawValue.value);
            break;
        }

        bindings[this.prefixVariableQuestionMark ? '?' + key : key] = value;
      }

      return bindings;
    }
    /**
     * Convert a SPARQL JSON boolean response to a boolean.
     * This will throw an error if the given reponse was not a valid boolean response.
     * @param sparqlResponse A SPARQL JSON response.
     * @return {IBindings[]} An array of bindings.
     */

  }, {
    key: "parseJsonBoolean",
    value: function parseJsonBoolean(sparqlResponse) {
      if ('boolean' in sparqlResponse) {
        return sparqlResponse.boolean;
      }

      throw new Error('No valid ASK response was found.');
    }
    /**
     * Convert a SPARQL JSON boolean response stream to a promise resolving to a boolean.
     * This will reject if the given reponse was not a valid boolean response.
     * @param {NodeJS.ReadableStream} sparqlResponseStream A SPARQL JSON response stream.
     * @return {NodeJS.ReadableStream} A stream of bindings.
     */

  }, {
    key: "parseJsonBooleanStream",
    value: function parseJsonBooleanStream(sparqlResponseStream) {
      return new Promise(function (resolve, reject) {
        sparqlResponseStream.on('error', reject);
        sparqlResponseStream.pipe(require('JSONStream').parse('boolean')).on('data', resolve).on('end', function () {
          return reject(new Error('No valid ASK response was found.'));
        });
      });
    }
  }]);

  return SparqlJsonParser;
}();

exports.SparqlJsonParser = SparqlJsonParser;